module.exports = __webpack_public_path__ + "static/media/item_40_5.9fe21571.png";